import { ref } from "vue";

import { TPermission } from "@/types/permission";

// FIXME move to TPermission type
export interface ITempPermission {
  name: TPermission;
  type: "subscription" | "unsupported" | "supported"; // unsupported - Нет установленного модуля в столовой;
  available: boolean;
  priority?: number; // FIXME uncheck temporal
}

const permissions = ref<ITempPermission[]>([]);

export function usePermissions() {
  async function definePermission(payload: ITempPermission[]) {
    permissions.value = payload;
  }

  function isAllow(name: TPermission | TPermission[]): boolean {
    if (!Array.isArray(permissions.value)) return false;

    if (Array.isArray(name)) {
      return name.some(
        (n) => !!permissions.value.find((p) => p.name === n)?.available,
      );
    }

    return !!permissions.value.find((p) => p.name === name)?.available;
  }

  function getDenyType(name: TPermission | TPermission[]): string | undefined {
    if (!Array.isArray(permissions.value)) return undefined;

    const key = Array.isArray(name) ? name[0] : name;
    return permissions.value.find((p) => p.name === key)?.type;
  }

  return {
    permissions,
    isAllow,
    getDenyType,
    definePermission,
  };
}
